import * as React from "react";
import { UitkCarousel } from "uitk-react-carousel";
import { IsomorphicCarouselProps } from "./typings";
import { ItemKeyHelper } from "src/components/utility/ItemKeyHelper";

function maxedOrLengthVisible(array: any[], max: number) {
  if (array.length === 1) {
    return 1;
  }

  return array.length > max ? max : array.length - 1;
}

/**
 * Adjusts (if necessary) the props.itemsVisible to be compatible with the size of props.children.
 * uitk-react-carousel will fail if given < or == number of children than specified in itemsVisible.
 * Takes same props as uitk-react-carousel
 * @param {IsomorphicCarouselProps} carouselProps
 * @returns {IsomorphicCarouselProps} IsomorphicCarouselProps
 */
export function normalizeItemsVisible(carouselProps: IsomorphicCarouselProps): IsomorphicCarouselProps {
  if (carouselProps.children.length < 1) {
    return carouselProps;
  }

  const normalizedProps = { ...carouselProps };

  normalizedProps.itemsVisible = {
    lg: maxedOrLengthVisible(carouselProps.children, carouselProps.itemsVisible.lg),
    md: maxedOrLengthVisible(carouselProps.children, carouselProps.itemsVisible.md),
    sm: maxedOrLengthVisible(carouselProps.children, carouselProps.itemsVisible.sm),
  };

  return normalizedProps;
}

const ServerSideCarousel = (props: IsomorphicCarouselProps) => {
  const itemClassName = `uitk-cell
    s-cell-1-${props.itemsVisible.sm}
    m-cell-1-${props.itemsVisible.md}
    l-cell-1-${props.itemsVisible.lg}
    xl-cell-1-${props.itemsVisible.lg}`;

  const keyHelper = new ItemKeyHelper("IsomporphicCarousel");
  const classes = `${props.className} uitk-scroll-horizontal uitk-grid uitk-cell server-side-carousel`;

  return (
    <div className={classes}>
      <ul className="uitk-grid uitk-cell no-bullet all-x-gutter-three list all-l-margin-zero all-l-padding-zero">
        {props.children.map((child) => (
          <div key={keyHelper.next()} className={itemClassName}>
            {child}
          </div>
        ))}
      </ul>
    </div>
  );
};

/**
 * Workaround to render something server-side since uitk-react-carousel is only client-side.
 * Normalizes itemsVisble prop to protect against bugs in uitk-react-carousel when itemsVisble disagrees with the actual number of chilren
 * Takes same props as uitk-react-carousel.
 * @param {IsomorphicCarouselProps} props
 */
export const IsomorphicCarousel = (props: IsomorphicCarouselProps) => {
  const carouselProps = normalizeItemsVisible(props);

  // test for window.name allows ServerSideCarousel to be rendered during unit testing, irrelevant in prod and actual browser
  if (typeof window === "undefined" || window.name === "nodejs") {
    return <ServerSideCarousel {...carouselProps} />;
  } else {
    return <UitkCarousel {...carouselProps} />;
  }
};

export default IsomorphicCarousel;
